// extracted by mini-css-extract-plugin
export default {"page":"sk-z","cartModal":"tk-z","checkout":"uk-z","placeholder":"vk-z","account":"wk-z"};